import { render } from "./Puffercat_Apps.vue?vue&type=template&id=4e3948b8&scoped=true&ts=true"
import script from "./Puffercat_Apps.vue?vue&type=script&lang=ts"
export * from "./Puffercat_Apps.vue?vue&type=script&lang=ts"

import "./Puffercat_Apps.vue?vue&type=style&index=0&id=4e3948b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3948b8"]])

export default __exports__